export const jobStatusValues = [
  'CANCELED',
  'CREATED',
  'FAILED',
  'MANUAL',
  'SUCCESS',
  'PENDING',
  'PREPARING',
  'RUNNING',
  'SCHEDULED',
  'SKIPPED',
  'WAITING_FOR_RESOURCE',
];
